<template>
  <el-card>
    <el-table :data="tableData" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }">
      <el-table-column prop="flowConfigStepName" label="审批单名称" align="center">
        <template slot-scope="{ row }">
          {{ `${row.flowApplyOverview.applyStaffName}提交的${getType(row.flowApplyOverview.applyType, row.flowApplyOverview.applyState,row.flowCancelDTO && row.flowCancelDTO.financeCancelType)}` }}
        </template>
      </el-table-column>
      <el-table-column prop="auditStaffName" label="审批单概要" align="center">
        <template slot-scope="scope">
          <div v-if="item.value" v-for="(item, index) in getDetail(scope.row)" :key="index">
            <span>{{ item.label }}</span>
            <span>{{ item.value }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="operateType" label="申请人" align="center">
        <template slot-scope="scope">
          {{ scope.row.flowApplyOverview.applyStaffName }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="申请日期" align="center">
        <template slot-scope="scope">
          {{ cutTime(scope.row.flowApplyOverview.createTime, ' ') }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="审批节点" align="center">
        <template slot-scope="scope">
          {{ scope.row.flowApplyOverview.currentNode || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="审批结果" align="center">
        <template slot-scope="scope">
          {{ dictType('applyStateArr', scope.row.flowApplyOverview.applyState) }}
        </template>
      </el-table-column>
      <el-table-column label="审批日期" align="center" width="150">
        <template slot-scope="scope">
          {{ cutTime(scope.row.flowApplyOverview.lastApplyTime, ' ') }}
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" fixed="right" width="120" align="center">
        <template slot-scope="scope">
          <el-link type="primary" @click="preview(scope.row.flowApplyOverview)">详情</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="total, prev, pager, next, jumper,sizes"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :page-sizes="[10, 50, 100]"
      :total="total"
      @size-change="currentChange"
      @current-change="currentChange"
    />
  </el-card>
</template>

<script>
import { flowAuditLogPage, flowAuditLogCount } from '@/api/workflow'
export default {
  inject: ['indexThis'],
  data() {
    return {
      tableData: [],
      total: 0,
      page: {
        pageNo: 1,
        pageSize: 10,
      },
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      const { data } = await flowAuditLogPage(this.page)
      this.tableData = data || []
      const { data: total } = await flowAuditLogCount(this.page)
      this.total = parseInt(total || 0)
    },
    // 详情
    preview(value) {
      const type = value.applyType
      this.indexThis.applyOverviewId = value.id
        this.indexThis.isExamine = false
      if (type === 2) {
        this.indexThis.$refs['flowVacationDetail'].getDetail(value.id)
        this.indexThis.$refs['flowVacationDetail'].drawer = true
      } else if (type === 12) {
        this.indexThis.$refs['flowMendDetailDTO'].getDetail(value.id)
        this.indexThis.$refs['flowMendDetailDTO'].drawer = true
      } else if (type === 4) {
        this.indexThis.$refs['flowMaterialDetail'].getDetail(value.id)
        this.indexThis.$refs['flowMaterialDetail'].drawer = true
      } else if (type === 3) {
        this.indexThis.$refs['flowTravelDetail'].getDetail(value.id)
        this.indexThis.$refs['flowTravelDetail'].drawer = true
      } else if (type === 1) {
        this.indexThis.$refs['flowReimbursementDetail'].getDetail(value.id)
        this.indexThis.$refs['flowReimbursementDetail'].drawer = true
      } else if (type === 5) {
        this.indexThis.$refs['flowApplyPre'].getDetail(value.id)
        this.indexThis.$refs['flowApplyPre'].drawer = true
      } else if (type === 6) {
        this.indexThis.$refs['flowApplyRefund'].getDetail(value.id)
        this.indexThis.$refs['flowApplyRefund'].drawer = true
      } else if (type === 8) {
        this.indexThis.$refs['flowUseSealInfoDTO'].getDetail(value.id)
        this.indexThis.$refs['flowUseSealInfoDTO'].drawer = true
      } else if (type === 10) {
        this.indexThis.$refs['flowBorrowMaterialInfoDTO'].getDetail(value.id)
        this.indexThis.$refs['flowBorrowMaterialInfoDTO'].drawer = true
      } else if (type === 11) {
        this.indexThis.$refs['materialPurchaseDTO'].getDetail(value.id)
        this.indexThis.$refs['materialPurchaseDTO'].drawer = true
      } else if (type === 13) {
        this.indexThis.$refs['flowApplyCommercePre'].getDetail(value.id)
        this.indexThis.$refs['flowApplyCommercePre'].drawer = true
      } else if (type === 14) {
        this.indexThis.$refs['flowApplyCommerceRefund'].getDetail(value.id)
        this.indexThis.$refs['flowApplyCommerceRefund'].drawer = true
      }else if (type === 15) {
        this.indexThis.$refs['VoidModuleCommerceRefund'].getDetail(value.id)
        this.indexThis.$refs['VoidModuleCommerceRefund'].ispaymentSn = true
        this.indexThis.$refs['VoidModuleCommerceRefund'].drawer = true
      }
    },

    currentChange() {
      this.getList()
    },

    getType(type, state,financeCancelType ) {
      if (type === 2) {
        if (state == 11 || state == 12 || state == 13) {
          return '销假申请'
        } else {
          return '请假申请'
        }
      } else if (type === 12) {
        return '补卡申请'
      } else if (type === 4) {
        return '物资申请'
      } else if (type === 3) {
        return '出差申请'
      } else if (type === 1) {
        return '报销申请'
      } else if (type === 5) {
        return '优惠申请'
      } else if (type === 6) {
        return '退款申请'
      } else if (type === 8) {
        return '用章申请'
      } else if (type === 10) {
        return '物资借用'
      } else if (type === 11) {
        return '采购申请'
      } else if (type === 13) {
        return '合同优惠'
      } else if (type === 14) {
        return '合同退款'
      }else if(type === 15){
        if (financeCancelType == 1) {
          return '作废收款'
        } else if(financeCancelType == 2) {
          return '作废退款'
        }else if(financeCancelType == 3) {
          return '作废预存'
        }
      }
    },

    getDetail(item) {
      const { applyType } = item.flowApplyOverview
      if (applyType === 1) {
        // 报销
        return [
          { label: '报销类型：', value: item.flowReimbursementDetail.reimbursementTypeName },
          { label: '报销总额：', value: `￥${item.flowReimbursementDetail.reimbursementAmount}` },
        ]
      } else if (applyType === 2) {
        // 请假
        const timeUnit = item.flowVacationDetail.timeUnit
        const beginStatus = item.flowVacationDetail.beginStatus === 1 ? '上午' : '下午'
        const beginTime = this.formatDate(item.flowVacationDetail.beginTime, timeUnit === 1 ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD')
        const endStatus = item.flowVacationDetail.endStatus === 1 ? '上午' : '下午'
        const endTime = this.formatDate(item.flowVacationDetail.endTime, timeUnit === 1 ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD')
        return [
          { label: '请假类型：', value: item.flowVacationDetail.vacationName },
          { label: '开始时间：', value: timeUnit === 1 ? beginTime : `${beginTime} ${beginStatus}` },
          { label: '结束时间：', value: timeUnit === 1 ? endTime : `${endTime} ${endStatus}` },
        ]
      } else if (applyType === 3) {
        // 出差
        return [
          { label: '出差城市：', value: `${item.flowTravelDetail.fromCityName}-${item.flowTravelDetail.endCityName}` },
          { label: '开始时间：', value: this.formatDate(item.flowTravelDetail.beginTime, 'YYYY-MM-DD HH:mm') },
          { label: '结束时间：', value: this.formatDate(item.flowTravelDetail.endTime, 'YYYY-MM-DD HH:mm') },
        ]
      } else if (applyType === 4) {
        // 物资
        return [
          { label: '仓库名称：', value: item.flowMaterialDetail.warehouseName },
          { label: '申请原因：', value: item.flowMaterialDetail.applyReason },
        ]
      } else if (applyType === 5 || applyType === 13) {
        // 优惠申请
        return [
          { label: '小区名称：', value: item.flowApplyPre.communityName },
          { label: '收费科目：', value: item.flowApplyPre.itemName },
          { label: '优惠金额：', value: this.keepTwoDecimal(item.flowApplyPre.preferentialAmount) },
        ]
      } else if (applyType === 6 || applyType === 14) {
        // 退款申请
        return [
          { label: '小区名称：', value: item.flowApplyRefund.communityName },
          { label: '收费科目：', value: item.flowApplyRefund.itemTargetName },
          { label: '退款金额：', value: this.keepTwoDecimal(item.flowApplyRefund.refundAmount) },
        ]
      } else if (applyType === 8) {
        // 用章审批
        return [
          { label: '所属部门：', value: item.flowUseSealInfoDTO.departmentName },
          { label: '开始时间：', value: this.formatDate(item.flowUseSealInfoDTO.beginTime, 'YYYY-MM-DD') },
          { label: '结束时间：', value: this.formatDate(item.flowUseSealInfoDTO.endTime, 'YYYY-MM-DD') },
        ]
      } else if (applyType === 10) {
        // 物资借用
        return [
          { label: '物资名称：', value: item.flowBorrowMaterialInfoDTO.materialName },
          { label: '借用数量：', value: `${item.flowBorrowMaterialInfoDTO.borrowCount} ${this.dictType('materialUnit', item.flowBorrowMaterialInfoDTO.unit)}` },
          { label: '借用时间：', value: this.formatDate(item.flowBorrowMaterialInfoDTO.beginTime, 'YYYY-MM-DD HH:mm:ss') },
          { label: '归还时间：', value: this.formatDate(item.flowBorrowMaterialInfoDTO.endTime, 'YYYY-MM-DD HH:mm:ss') },
        ]
      } else if (applyType === 11) {
        // 采购申请
        return [
          { label: '存放仓库：', value: item.materialPurchaseDTO.warehouseName },
          { label: '物资分类：', value: item.materialPurchaseDTO.materialCategoryName },
        ]
      } else if (applyType === 12) {
        // 补卡
        return [
          { label: '直属部门：', value: item.flowMendDetailDTO.departmentName },
          { label: '补卡时间：', value: this.formatDate(item.flowMendDetailDTO.mendTime, 'YYYY-MM-DD HH:mm:ss') },
          { label: '申请日期：', value: this.formatDate(item.flowMendDetailDTO.createTime, 'YYYY-MM-DD') },
        ]
      } else if (applyType === 15) {
        // 作废
        return [
          { label: '小区名称：', value: item.flowCancelDTO.communityName },
          { label: '单据编号：', value: item.flowCancelDTO.paymentSn },
          { label: '作废原因：', value: item.flowCancelDTO.voidCheckReason },
        ]
      }
    },
  },
}
</script>
